let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("83wMe")).then(() => parcelRequire('2jl59'));